module.exports = __webpack_public_path__ + "static/media/c02-01-1.2e9a9973.png";